import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';
import { useCardPaymentEnabled } from 'src/composables/useCardPaymentEnabled';
import { requireCardPayment } from 'src/router/guards/requireCardPayment';

const { $gettext } = gettext;

export const subscriptionRoutes: RouteRecordRaw[] = [
  {
    path: 'overview',
    alias: $gettext('prehled'),
    name: 'subscription-overview',
    component: () => import('src/pages/MyTariffPage.vue'),
  },
  {
    path: 'tarif',
    name: 'subscription-tarif',
    component: () => import('src/pages/SubscriptionPage.vue'),
  },
  {
    path: 'platby',
    alias: $gettext('platby'),
    name: 'subscription-payments',
    component: () => import('src/pages/profile/PaymentsPage.vue'),
  },
  {
    path: 'platebni-metoda',
    alias: $gettext('platebni-metoda'),
    name: 'subscription-payment-method',
    component: () => import('src/pages/subscription/PaymentMethodPage.vue'),
    beforeEnter: () => requireCardPayment(() => useCardPaymentEnabled().value),
  },
];
